require('../../../../../node_modules/intl-tel-input/build/css/intlTelInput.css');
require('./style.scss');

import {validatePhoneNumber, getIsoCode, getCountry, getCurrentCountry} from 'a_root-folder/lib/service/geo.service';
import intlTelInput from "intl-tel-input";
import phone from 'phone';
let intlTel = null;

const getSelectedIso = () => {
    return intlTel.getSelectedCountryData().iso2;
}

const formatCountryInput = (input, isoCode) => {
    return new Promise((res, rej) => {

        if(!isoCode){
            getCurrentCountry()
                .then((country_name) => {
                    const countryIsoCode = getIsoCode(country_name);

                    intlTel = intlTelInput(input, {initialCountry: countryIsoCode});

                    res({name: country_name, isoCode: countryIsoCode});
                })
                .catch((err) => {
                    rej(err);
                })
        }else{
            intlTel = intlTelInput(input, {initialCountry: isoCode});

            res({name: countryName, isoCode});
        }
    })
}

export const showCreatedModalBrokenWebrtc = (translate, send) => {
    let countryName = null;
    let countryIsoCode = null;

    const sendPhone = (e) => {
        e.preventDefault();

        send({phone: getPhone(e), isoCode: countryIsoCode});
    }

    const onSubmit = (e) => {
        e.preventDefault();

        clearErroMsg();
        const phoneNumber = getPhone(e);
        countryIsoCode = getSelectedIso();
        countryName = getCountry(countryIsoCode);

        validatePhoneNumber(phoneNumber, countryIsoCode)
            .then(({phone}) => {
                sendPhone(e, {phone, country: countryName, isoCode: countryIsoCode})
            })
            .catch(({err}) => {
                console.log(err)
                addErroMsg(`${translate('INVALID_PHONE_NUMBER')} `);
            })
    }

    const clearErroMsg = () => {
        const errValidationPhoneContainer = document.body.querySelector('.err-validation-phone-container');
        const errValidationPhoneMsg = document.body.querySelector('.err-validation-phone-msg');

        errValidationPhoneContainer.classList.add('hidden');
        errValidationPhoneMsg.innerHTML = '';
    }

    const addErroMsg = (msg) => {
        const errValidationPhoneContainer = document.body.querySelector('.err-validation-phone-container');
        const errValidationPhoneMsg = document.body.querySelector('.err-validation-phone-msg');

        errValidationPhoneContainer.classList.remove('hidden');
        errValidationPhoneMsg.innerHTML = msg;
    }

    const getPhone = () => {
        return document.body.querySelector('.broken-webrtc-input').value;
    }

    const addErroBlock = (send) => {
        const errPhone = document.createElement('p');
        errPhone.classList.add('err-validation-phone-container');
        errPhone.classList.add('hidden');
        const errPhoneMsg = document.createElement('span');
        errPhoneMsg.classList.add('err-validation-phone-msg');
        const errPhoneButton = document.createElement('a');
        errPhoneButton.classList.add('err-validation-phone-button');
        errPhoneButton.innerText = translate('IGNORE_AND_SEND_ANYWAYS');
        errPhoneButton.style.textDecoration = 'underline';
        errPhoneButton.style.cursor = 'pointer';
        errPhoneButton.addEventListener('click', send);

        errPhone.appendChild(errPhoneMsg);
        errPhone.appendChild(errPhoneButton);

        return errPhone;
    }

    const container = document.createElement('div');
    container.classList.add('broken-webrtc-container');

    const body = document.createElement('div');
    body.classList.add('broken-webrtc');
    const span = document.createElement('span');
    span.classList.add('broken-webrtc-label');

    const form = document.createElement('form');
    const pText = document.createElement('p');
    pText.innerText = translate('BROKEN_WEBRTC_MSG');
    const pInput = document.createElement('div');
    pInput.classList.add('broken-webrtc-container');
    const input = document.createElement('input');
    input.type = 'text';
    input.placeholder = 'Phone number';
    input.classList.add('broken-webrtc-input');
    pInput.appendChild(input);


    const submit = document.createElement('button');
    submit.classList.add('check-password-submit');
    submit.classList.add('button');
    submit.type = 'submit';
    submit.value = translate('CALL_ME');
    submit.innerHTML = translate('CALL_ME');
    form.onsubmit = onSubmit;
    pInput.appendChild(submit);

    form.appendChild(pText);
    form.appendChild(pInput);
    form.appendChild(addErroBlock(sendPhone));

    body.appendChild(span);
    body.appendChild(form);
    container.appendChild(body);

    formatCountryInput(input)
        .then(({name, isoCode}) => {
            countryName = name;
            countryIsoCode = isoCode;
        })

    return container;
}

export const connectViaPhone = (text, {phone: num, isoCode}) => {
    const phoneData = phone(num, getCountry(isoCode));
    const tel = phoneData.length ? phoneData[0] : num;

    const container = document.createElement('div');
    container.classList.add('connect-via-phone-container');

    const body = document.createElement('div');
    body.classList.add('connect-via-phone');
    const span = document.createElement('span');
    span.classList.add('connect-via-phone-label');

    var pText = document.createElement('p');
    pText.innerText = text;

    var pPhone = document.createElement('p');
    var phoneDiv = document.createElement('div');
    phoneDiv.classList.add('phone');
    var a = document.createElement('a');
    a.href = `tel:${tel}`;
    a.innerText = tel;

    const input = document.createElement('input');
    input.type = 'text';
    input.placeholder = 'Phone number';
    input.classList.add('broken-webrtc-input');
    input.classList.add('hidden');
    input.value = phoneData[0];

    pPhone.classList.add('phone-container');

    pPhone.appendChild(input);
    pPhone.appendChild(a);

    intlTelInput(input, {initialCountry: isoCode});

    body.appendChild(span);
    body.appendChild(pText);
    body.appendChild(pPhone);
    container.appendChild(body);

    return container;
}

export const waitForPhoneNumber = (text) => {
    const container = document.createElement('div');
    container.classList.add('wait-for-phone-number-container');

    const body = document.createElement('div');
    body.classList.add('wait-for-phone-number-text');

    var pText = document.createElement('p');
    pText.innerText = text;

    body.appendChild(pText);
    container.appendChild(body);

    return container;
}
